import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';

import { IHttpOptions } from '@models';
import { environment } from 'environments/environment';
import { DataCentralService } from './data-central.service';
import { Observable } from 'rxjs';

interface IVersionResponse {
  app: string;
  build: number;
  required: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  private readonly BASE_URL = environment.baseURL;

  constructor(
    private http: HttpClient,
    private dataCentralService: DataCentralService,
    private navCtrl: NavController
  ) {}

  public http_get(options: IHttpOptions): Promise<unknown> {
    const { endpoint, param, needToken } = options;
    const API = options.api;

    if (!API) {
      console.warn('[HTTP] Error en el request, No se ha especificado una API');
      return Promise.reject(new Error('No API specified'));
    }

    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders();
      if (needToken) headers = headers.append('Authorization', 'Bearer ' + this.dataCentralService.accessToken);

      let url: string;
      if (param) {
        url = endpoint ? `${this.BASE_URL}/${API}/${endpoint}${param}` : `${this.BASE_URL}/${API}${param}`;
      } else {
        url = endpoint ? `${this.BASE_URL}/${API}/${endpoint}` : `${this.BASE_URL}/${API}`;
      }

      this.http.get(url, { headers }).subscribe({
        next: (data) => resolve(data),
        error: async (err: HttpErrorResponse) => {
          if (err.status === 401) await this.onUnauthorized();
          console.error('[HTTP] Error en el request -> ', err);
          reject(err);
        }
      });
    });
  }

  public http_post(options: IHttpOptions): Promise<unknown> {
    const { endpoint, body, needToken, responseType } = options;
    const API = options.api;

    if (!body) {
      console.warn('[HTTP] Error en el request, No se ha enviado ningun body');
      return Promise.reject(new Error('No body provided'));
    }

    if (!API) {
      console.warn('[HTTP] Error en el request, No se ha especificado una API');
      return Promise.reject(new Error('No API specified'));
    }

    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      if (needToken) headers = headers.append('Authorization', 'Bearer ' + this.dataCentralService.accessToken);

      const requestOptions: Record<string, unknown> = { headers };
      if (responseType) requestOptions['responseType'] = responseType;

      const url = endpoint ? `${this.BASE_URL}/${API}/${endpoint}` : `${this.BASE_URL}/${API}`;

      this.http.post(url, body, requestOptions as object).subscribe({
        next: (data) => resolve(data),
        error: async (err: HttpErrorResponse) => {
          if (err.status === 401) await this.onUnauthorized();
          console.error('[HTTP] Error en el request -> ', err);
          reject(err);
        }
      });
    });
  }
  public getVersions(): Observable<IVersionResponse[]> {
    const randomString = Math.random().toString(36).substring(2);
    return this.http.get<IVersionResponse[]>(`https://api.lancergroup.org/apps_build_config.json?${randomString}`);
  }
  /**PRIVATE METHODS */
  private async onUnauthorized(): Promise<void> {
    if (window.location.pathname.includes('/login') || window.location.pathname.includes('/sign-up')) return;
    await this.navCtrl.navigateRoot('/login');
  }
}
